import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["actions", "onActionClick", "className", "showTooltip"];
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import noop from 'lodash/noop';
import { EMPTY_OBJECT } from '@tekion/tekion-base/app.constants';
import Menu from '../Menu';
import Content from '../../atoms/Content';
import Tooltip from '../../atoms/tooltip';
var MenuItem = Menu.Item;
var ActionListOverlay = /*#__PURE__*/function (_PureComponent) {
  _inherits(ActionListOverlay, _PureComponent);
  var _super = _createSuper(ActionListOverlay);
  function ActionListOverlay() {
    var _this;
    _classCallCheck(this, ActionListOverlay);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "handleClick", function (_ref) {
      var key = _ref.key,
        domEvent = _ref.domEvent;
      domEvent.stopPropagation();
      var onActionClick = _this.props.onActionClick;
      onActionClick(key);
    });
    _defineProperty(_assertThisInitialized(_this), "renderMenuItem", function () {
      var action = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : EMPTY_OBJECT;
      return /*#__PURE__*/React.createElement(MenuItem, {
        key: action.id,
        value: action.id,
        className: action.disabled ? 'is-disabled' : action.className || '',
        disabled: action.disabled
      }, /*#__PURE__*/React.createElement(Content, null, action.name));
    });
    _defineProperty(_assertThisInitialized(_this), "renderMenuItemWithTooltip", function () {
      var action = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : EMPTY_OBJECT;
      return /*#__PURE__*/React.createElement(MenuItem, {
        key: action.id,
        value: action.id,
        className: action.disabled ? classnames('is-disabled', action.disabledClassName) : action.className || '',
        disabled: action.disabled
      }, /*#__PURE__*/React.createElement(Tooltip, {
        title: action.tooltipTitle || null
      }, /*#__PURE__*/React.createElement(Content, null, action.name)));
    });
    return _this;
  }
  _createClass(ActionListOverlay, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        actions = _this$props.actions,
        onActionClick = _this$props.onActionClick,
        className = _this$props.className,
        showTooltip = _this$props.showTooltip,
        restProps = _objectWithoutProperties(_this$props, _excluded);
      var renderMenuItem = showTooltip ? this.renderMenuItemWithTooltip : this.renderMenuItem;
      return /*#__PURE__*/React.createElement(Menu, _extends({}, restProps, {
        onClick: this.handleClick,
        className: className
      }), actions.map(renderMenuItem));
    }
  }]);
  return ActionListOverlay;
}(PureComponent);
ActionListOverlay.propTypes = {
  actions: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string,
    icon: PropTypes.string
  })).isRequired,
  onActionClick: PropTypes.func,
  className: PropTypes.string,
  showTooltip: PropTypes.bool
};
ActionListOverlay.defaultProps = {
  onActionClick: noop,
  className: '',
  showTooltip: false
};
export default ActionListOverlay;